import React from 'react';
import { Link as L } from 'react-router-dom';

export { BrowserRouter as Router, Route, Switch, useRouteMatch, useParams, Prompt } from 'react-router-dom';

export const Link = (props) => <L {...props} style={{ textDecoration: 'none', ...props.style }} />;

export { useHistoryWithSpec } from './useHistoryWithSpec';
